import DeleteDataItemRequestModelBase from '../_generated/modelBases/delete-data-item-request-model-base';

export default class DeleteDataItemRequestModel extends DeleteDataItemRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
